import {Observable, Observer} from 'rxjs';

/**
 * Usage:
 *
 * this.store.pipe(
 *   select(selectSomeData),
 *   memoize()
 * .subscribe((result: any) => { ...  });
 *
 */
export const memoize = <T>(): ((source: Observable<T>) => Observable<T>) => {
  let previousValueSerialized: string | undefined;
  let previousValue: T;

  return (source: Observable<T>) => {
    return new Observable((observer: Observer<T>) => {
      return source.subscribe({
        next(x: T) {
          try {
            // stringify for comparison
            //
            const nextValue = JSON.stringify(x);

            if (nextValue !== previousValueSerialized) {
              previousValueSerialized = nextValue;
              previousValue = x;

              observer.next(x);
            } else {
              observer.next(previousValue);
            }
          } catch (e) {
            // TODO better error message
            observer.error('Data is not a JSON parsable object.');
          }
        },
        error(err) {
          observer.error(err);
        },
        complete() {
          observer.complete();
        }
      });
    });
  };
};
